import { CloudAccount } from "../../schema/types/cloudaccount/entity";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export interface CloudAccountTableItem extends CloudAccount {
  selfLink: string;
}

interface GetCloudAccountTableItemProps {
  link?: string;
  name?: string;
  item?: CloudAccount;
}
export function getCloudAccountTableItem({ link, name, item }: GetCloudAccountTableItemProps): CloudAccountTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "cloudaccount",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      provider: "" as any,
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "cloudaccount",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    provider: "" as any,
    lastModified: "",
    tags: {},
    version: 1,
  };
}
